import { useCallback } from 'react';

import { PopupType } from '../components/popup/types';
import { useGameConfig } from '../config/GameConfigProvider';
import { useCoreDispatch } from '../store/CoreStore';
import { useConfigSlice } from '../store/slices/config/selectors';
import { popupActions } from '../store/slices/popup/slice';

import { openUrl } from './helpers/openUrl';
import { useLobbyURLConnected } from './useLobbyURLConnected';
import { useShouldStayConnected } from './useShouldStayConnected';
import { useSlotsRedirectFunction } from './useSlotsRedirectFunction';

export const useLobbyRedirectFunction = (): (() => void) => {
  const dispatch = useCoreDispatch();

  // LOBBY-265: Because of 'gameLobbySymbol' key never being explicitlly cleared
  // it's preserved after redirection from a slot game to slots lobby.
  // Thus invalid 'gameLobbySymbol' can make an LC game appear in slots b2g component, but the game is not actually active.
  const lobbyUrl = useLobbyURLConnected(undefined, { gameLobbySymbol: '' });
  const shouldStayAtTable = useShouldStayConnected();
  const isCrashGame = useGameConfig().config.isCrashGame;
  const isSlotsLobbyValue = useConfigSlice.getIsSlotsLobby();
  const isSlotsLobby = isCrashGame && isSlotsLobbyValue; // slots redirection is only for crash games.
  const handleSlotRedirect = useSlotsRedirectFunction();

  const handleRedirect = useCallback(() => {
    if (shouldStayAtTable) {
      dispatch(popupActions.pushPopup(PopupType.DontLeaveRoundInProgress));
      return;
    }
    if (isSlotsLobby) {
      handleSlotRedirect();
      return;
    }
    openUrl(lobbyUrl);
  }, [dispatch, handleSlotRedirect, isSlotsLobby, lobbyUrl, shouldStayAtTable]);

  return handleRedirect;
};
